import React from 'react';
import { RouteObject } from 'react-router-dom';
import { CopilotIntegrationRoutes } from './routesHelper';

const CopilotIntegrationPage = React.lazy(
  () => import('./containers/CopilotIntegrationPage')
);

export const copilotIntegrationRoutes: RouteObject[] = [
  {
    path: `${CopilotIntegrationRoutes.ListTenants}`,
    element: (
      <React.Suspense fallback={null}>
        <CopilotIntegrationPage />
      </React.Suspense>
    ),
  },
];
